'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TYPE = exports.TYPE = ['@type'];
var FALLBACK = exports.FALLBACK = ['fallback'];
var USER_IDS = exports.USER_IDS = ['userIds'];
var TEAM_IDS = exports.TEAM_IDS = ['teamIds'];
var BOT_ID = exports.BOT_ID = ['botId'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/routing-rules/operators/keyPaths.js
// module id = 921
// module chunks = 2 3